function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: ['Check', { title: 'Date', filter: 'dateFull' }, 'Vendor', { title: 'Amount', filter: 'toCurrency' }, 'Status', { title: 'Status Date', filter: 'dateFull' }],
            fields: ['number', 'check_date', 'vendor.name', 'amount', 'status', 'status_date'],
            items: [],
            closedPeriod: null
        };
    },
    mounted: function mounted() {

        var $el = this;

        Event.$on('add-check', function () {
            Event.$emit('ap-add-check');
        });

        Event.$on('update-check', function (item, idx) {
            alert('Update entry...');
            //Event.$emit('show-flyout','Jounral Entry Details','/prototype/accounting/general-ledger/journal-entry/view','edit-journal-entry');
        });

        Event.$on('remove-check', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/accounts-payable/check/delete', 'delete-check');
        });

        Event.$on('delete-check', function (item) {
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        });

        Event.$on('view-check', function (item, idx) {
            Event.$emit('show-flyout', 'Check Details', '', 'ap-view-check', item);
        });

        Event.$on('refresh-ap-checks', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
        });
    },


    methods: {
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'number';

            var _this = this;

            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var $el = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };
            axios.get('/prototype/accounting/general-ledger/settings/gl-close').then(function (response) {
                _this.closedPeriod = response.data;
                axios.post('/prototype/accounting/accounts-payable/checks/fetch', data).then(function (response) {

                    offset !== 0 ? $el.items = [].concat(_toConsumableArray($el.items), _toConsumableArray(response.data.checks)) : $el.items = response.data.checks;
                    //$el.address = response.data.property

                    $el.items.map(function (check) {
                        check['closed_at'] = moment(_this.closedPeriod.month + '/1/' + _this.closedPeriod.year).endOf('month').format("MM/DD/YYYY");
                        check['check_date'] = check.created_at;
                        //check['vendor'] = check.vendor ? check.vendor.name : ''
                        check['status'] = 'Entered';
                        check['status_date'] = moment(check.created_at).format('MM/DD/YYYY');
                        if (check.approved_date !== null) {
                            check['status'] = 'Approved';
                            check['status_date'] = check.approved_date;
                        }
                        if (check.printed_date !== null) {
                            check['status'] = 'Printed';
                            check['status_date'] = check.printed_date;
                        }
                        if (check.reconciled_date !== null) {
                            check['status'] = 'Reconciled';
                            check['status_date'] = check.reconciled_date;
                        }
                        if (check.is_voided) {
                            check['status'] = 'Voided';
                            check['status_date'] = check.updated_at;
                        }
                    });

                    Event.$emit('data-table-loaded');
                });
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/checks/CheckList.vue
// module id = CLT5
// module chunks = 0 1